import React, { useState, useEffect } from 'react';
import { Box, Card, Typography, CircularProgress, Chip, List, ListItem, ListItemText, ListItemSecondaryAction, Divider, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button, Switch, FormControlLabel,  } from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';
import { toast } from 'react-toastify';
import client from '../../api/client';
import CustomTextField from '../../components/CustomTextField';

const Subscribers = () => {
  const [shops, setShops] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedShop, setSelectedShop] = useState(null);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    fetchSubscribers();
  }, []);

  const fetchSubscribers = async () => {
    setLoading(true);
    try {
      const response = await client.get('/users/admin/shops/');
      const allShops = response.data.results || [];
      // فقط مشترکین
      setShops(allShops.filter(s => s.is_subscribed));
    } catch (error) {
      toast.error('خطا در دریافت لیست');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (shop) => {
    setSelectedShop(shop);
    setIsSubscribed(shop.is_subscribed);
    setEndDate(shop.subscription_end_date || '');
    setDialogOpen(true);
  };

  const handleSave = async () => {
    try {
      await client.put(`/users/admin/shops/${selectedShop.id}/`, {
        ...selectedShop,
        is_subscribed: isSubscribed,
        subscription_end_date: endDate || null,
      });
      toast.success('ذخیره شد');
      setDialogOpen(false);
      fetchSubscribers();
    } catch (error) {
      toast.error('خطا');
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold' }}>
        مشترکین
      </Typography>

      {shops.length === 0 ? (
        <Card sx={{ p: 4, textAlign: 'center' }}>
          <Typography color="text.secondary">
            مشترکی وجود ندارد
          </Typography>
        </Card>
      ) : (
        <Card>
          <List disablePadding>
            {shops.map((shop, index) => (
              <React.Fragment key={shop.id}>
                {index > 0 && <Divider />}
                <ListItem>
                  <ListItemText
                    primary={shop.shop_name}
                    secondary={
                      <>
                        {shop.mobile}
                        {shop.subscription_end_date && (
                          <Chip
                            label={`تا ${shop.subscription_end_date}`}
                            size="small"
                            sx={{ mr: 1 }}
                          />
                        )}
                      </>
                    }
                  />
                  <ListItemSecondaryAction>
                    <IconButton onClick={() => handleEdit(shop)}>
                      <EditIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              </React.Fragment>
            ))}
          </List>
        </Card>
      )}

      {/* Edit Dialog */}
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} fullWidth maxWidth="xs">
        <DialogTitle>ویرایش اشتراک</DialogTitle>
        <DialogContent>
          <Typography variant="subtitle1" sx={{ mb: 2 }}>
            {selectedShop?.shop_name}
          </Typography>
          
          <FormControlLabel
            control={
              <Switch
                checked={isSubscribed}
                onChange={(e) => setIsSubscribed(e.target.checked)}
              />
            }
            label="اشتراک فعال"
            sx={{ mb: 2 }}
          />

          <CustomTextField             label="تاریخ پایان اشتراک"
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>انصراف</Button>
          <Button variant="contained" onClick={handleSave}>ذخیره</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Subscribers;
